import { render, staticRenderFns } from "./commissionBack.vue?vue&type=template&id=522df68e&scoped=true"
import script from "./commissionBack.vue?vue&type=script&lang=js"
export * from "./commissionBack.vue?vue&type=script&lang=js"
import style0 from "./commissionBack.vue?vue&type=style&index=0&id=522df68e&prod&lang=scss&scoped=true"
import style1 from "./commissionBack.vue?vue&type=style&index=1&id=522df68e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522df68e",
  null
  
)

export default component.exports